import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  ViewChild,
  AfterViewInit,
  AfterContentInit
} from '@angular/core';
import {interval, Subscription} from 'rxjs';
import { Pagination } from '../models/pagination';
import { ResponsiveService } from 'src/app/core/services/responsive.service';
import { Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit, OnDestroy, OnChanges {

  @Input() hasAutoRefresh: boolean = false;
  private _totalItems = 0;
  @Input()
  set totalItems(value: number) {
    if (value !== this._totalItems) {
      this._totalItems = value;
      // console.log('totalItems cambiato:', value);
      if(!this.pagination) return;
      this.pagination.setNItems(this._totalItems);
      this.pagination.setNPages(this.pagination.calculateNPages());
      if(this.pagination.getCurrentPage() > 0 &&
        (this.pagination.getCurrentPage() + 1) > this.pagination.getNPages()) {
        //se mi trovo in ultima pagina con un solo elemento e cancello elemento
        this.pagination.decrementPage();
        if(this.refreshOnChange) {
          this.refreshEvent.emit(this.pagination);
          //dopo che cambio pagina corrente ricarico gli elementi
        }
      }
    }
  }

  get totalItems(): number {
    return this._totalItems;
  }
  @Input() resetCurrentPage: boolean;
  @Input() itemsPerPage: number = 10;
  @Input() refreshOnChange: boolean = true;
  @Output() refreshEvent: EventEmitter<Pagination> = new EventEmitter<Pagination>();
  isTabletSizeScreen = false;
  public  refreshIntervalDelay: string = '';
  private refreshInterval: Subscription;
  pagination: Pagination;

  constructor(private responsive: ResponsiveService) { }

  ngOnInit() {
    this.pagination = new Pagination(this.totalItems, this.itemsPerPage);
    if(this.hasAutoRefresh) {
      this.refreshIntervalDelay = '30';
      this.setRefreshInterval(this.refreshIntervalDelay);
    }
    this.responsive.checkScreenSizeDynamic([
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium
    ]).subscribe(
      state => this.isTabletSizeScreen = state.matches
    )
  }

  ngOnDestroy() {
    if(this.refreshInterval) {
      this.refreshInterval.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    //resetCurrentPage viene portato a true nel momento in cui si cambiano i filtri di una ricerca
    //per riazzerare la currentPage.
    if(changes.resetCurrentPage && changes.resetCurrentPage.currentValue === true) {
      if(this.pagination) this.pagination.reset();
    }
    if (changes.totalItems && !changes.totalItems.firstChange) {
      //se cambia il numero totale di elementi, per esempio dopo una ricerca, o dopo add/delete
      //devo modificare il numero totale di elementi e di pagine in this.pagination
      // this.pagination.setNItems(this.totalItems);
      // this.pagination.setNPages(this.pagination.calculateNPages());
      // if(this.pagination.getCurrentPage() > 0 &&
      //   (this.pagination.getCurrentPage() + 1) > this.pagination.getNPages()) {
      //   //se mi trovo in ultima pagina con un solo elemento e cancello elemento
      //   this.pagination.decrementPage();
      //   if(this.refreshOnChange) {
      //     //dopo che cambio pagina corrente ricarico gli elementi
      //     this.refreshEvent.emit(this.pagination);
      //   }
      // }
    }
  }

  onSelectItemsQty(event: number) {
    this.pagination.setItemsPerPage(event);
    this.itemsPerPage = Number(event);
    this.refreshEvent.emit(this.pagination);
  }

  increment() {
    if(this.pagination.getNItems() === 0) return;
    if((this.pagination.getCurrentPage() + 1) < (this.pagination.getNPages())) {
      this.pagination.incrementPage();
      this.refreshEvent.emit(this.pagination);
    }
  }

  decrement() {
    if(this.pagination.getCurrentPage() > 0) {
      this.pagination.decrementPage();
      this.refreshEvent.emit(this.pagination);
    }
  }

  setRefreshInterval(periodInMinutes: string) {
    if(this.refreshInterval) {
      this.refreshInterval.unsubscribe();
    }
    this.refreshIntervalDelay = periodInMinutes;
    if(periodInMinutes) {
      this.refreshInterval = interval(parseInt(periodInMinutes) * 1000 * 60).subscribe(() => {
        this.pagination.reset();
        this.refreshEvent.emit(this.pagination);
      });
    }
  }
}
